import { PropsWithChildren } from 'react';

import cs from 'classnames';
import { format, parseISO } from 'date-fns';
import { FieldPath } from 'react-hook-form';

import { parseDateRange } from 'components/shared/DatePicker/functions';
import { DatePickerPopover, getFormattedDatesRange } from 'components/shared/HookFormComponents/datePicker';
import {
  FieldValues,
  TInputDatePickerProps,
} from 'components/shared/HookFormComponents/datePicker/inputs/InputDatePicker';
import { AdapterType } from 'utils/types';

import s from './index.module.css';

export const DateValuePlank = function <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ field: { value }, mode }: AdapterType<TFieldValues, TName> & PropsWithChildren<TInputDatePickerProps>) {
  if (!value) return null;

  if (mode === 'range') {
    return <span>{getFormattedDatesRange(parseDateRange(value))}</span>;
  }

  return <span>{`${format(parseISO(value), 'MMMM d, yyyy')}`}</span>;
};

const DatePicker = function <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(props: AdapterType<TFieldValues, TName> & PropsWithChildren<TInputDatePickerProps>) {
  const { disabled } = props;

  return (
    <DatePickerPopover {...props}>
      <div className={cs(s.plankPrimary, { [s.disabledPrimary]: disabled })}>
        <DateValuePlank {...props} />
      </div>
    </DatePickerPopover>
  );
};

export { DatePicker };
export default DatePicker;
